/**
 * Created by vladislav on 2/4/19
 */

const DailyCupLeadersRow = RowView.extend({
    generateMedalAmount: function (place, amount) {
        const styles = cleverapps.styles.DailyCupLeadersRow;

        const medal = new cc.Sprite(bundles.table.frames[`badge_${place}`]);
        medal.setScale(0.7);

        const amountText = cleverapps.UI.generateImageText(amount, cleverapps.styles.FONTS.WHITE_TEXT);
        amountText.setAnchorPoint(0.5, 0.5);
        amountText.fitTo(styles.text.width);

        const amountWrap = new cc.Node();
        amountWrap.setAnchorPoint(0.5, 0.5);
        amountWrap.setContentSize2(styles.text.width, amountText.height);
        amountWrap.addChild(amountText);
        amountText.setAlignment(amountWrap.width / 2, amountWrap.height / 2);

        return new cleverapps.Layout([medal, amountWrap], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.iconMargin
        });
    },

    createScore: function () {
        const styles = cleverapps.styles.DailyCupLeadersRow;

        const items = [];
        items.push(this.generateMedalAmount(1, this.row.data.firstPlace));
        items.push(this.generateMedalAmount(2, this.row.data.secondPlace));
        items.push(this.generateMedalAmount(3, this.row.data.thirdPlace));

        const content = new cleverapps.Layout(items, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });
        
        content.setAlignment({ align: "center" }, { align: "center" });

        const background = new cc.Scale9Sprite(this.row.data.player ? bundles.table.frames.amount_bg_you_png : bundles.table.frames.amount_bg_png);
        background.setContentSize2(content.width, content.height);
        background.addChild(content);
        return background;
    }
});

cleverapps.styles.DailyCupLeadersRow = {
    text: {
        width: 70
    },

    iconMargin: 2,
    margin: 4,
    padding: {
        x: 15,
        y: 5
    }
};